import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const CollapsedItemWrapper = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${tokens.radius.large};
  cursor: pointer;
  background-color: ${({ active }) => (active ? '#03323F' : 'transparent')};
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${tokens.colors.dark5};
  }
`
